import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import utils from "../../../../../utils";
const ListComplements = ({
  produto,
  handleEditarComplemento,
  handleClickStopAndPause,
  handleDisableOrEnableComplement,
}) => {
  return (
    <>
      {produto?.complementos?.length > 0 &&
        produto.complementos.map((complementos) =>
          complementos.tipoComplemento !== "TAMANHO" ? (
            <Box paddingTop={1} key={complementos.id}>
              <Accordion square={true}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <ListItem dense>
                    <ListItemText
                      dense="true"
                      primary={
                        <Typography color="textPrimary" variant="button">
                          {complementos.descricao}
                        </Typography>
                      }
                      secondary={
                        <Typography color="textSecondary" variant="body1">
                          Qtd. min. {complementos.min} | Qtd. Máx.{" "}
                          {complementos.max}
                          {complementos.obrigatorio
                            ? " (obrigatório)"
                            : " (opcional)"}
                        </Typography>
                      }
                    />

                    <Button
                      startIcon={
                        !complementos.pausado ? (
                          <PauseCircleOutlineIcon />
                        ) : (
                          <PlayCircleOutlineIcon />
                        )
                      }
                      color={
                        !complementos.pausado
                          ? "primary"
                          : "secondary"
                      }
                      onClick={(event) => {
                        handleDisableOrEnableComplement(
                          event,
                          complementos
                        );
                      }}
                    >
                      {!complementos.pausado
                        ? "Pausar Complemento"
                        : "Iniciar Complemento"}
                    </Button>

                    <Button
                      startIcon={<EditIcon />}
                      onClick={(event) =>
                        handleEditarComplemento(event, complementos)
                      }
                    >
                      Editar
                    </Button>
                  </ListItem>
                </AccordionSummary>

                <AccordionDetails sx={{ padding: "0", margin: "0" }}>
                  <List dense={true} style={{ width: "100%" }}>
                    <Box sx={{ paddingX: "2rem" }}>
                      {complementos.complementoItens.map(
                        (complementoItem, index) => (
                          <React.Fragment key={complementoItem.id}>
                            <Grid
                              sx={{ padding: "0.5rem" }}
                              container
                              direction="row"
                            >
                              <Grid
                                size={{
                                  xs: 8,
                                  sm: 8,
                                }}
                              >
                                <ListItemText
                                  primary={complementoItem.descricao}
                                  secondary={utils.formatNumber(
                                    complementoItem.valor
                                  )}
                                />
                              </Grid>

                              <Grid
                                size={{
                                  xs: 4,
                                  sm: 4,
                                }}
                              >
                                <Box
                                  sx={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                  }}
                                >
                                  <Tooltip title={complementos.pausado ? "O complemento está pausado no momento" : ""}
                                  arrow
                                  >
                                    <Box>
                                      <Button
                                        disabled={complementos.pausado}
                                        startIcon={
                                          complementoItem.pausado ? (
                                            <PlayCircleOutlineIcon />
                                          ) : (
                                            <PauseCircleOutlineIcon />
                                          )
                                        }
                                        color={
                                          complementoItem.pausado
                                            ? "secondary"
                                            : "primary"
                                        }
                                        onClick={(event) => {
                                          handleClickStopAndPause(
                                            event,
                                            complementoItem,
                                            complementos
                                          );
                                        }}
                                      >
                                        {complementoItem.pausado
                                          ? "Iniciar"
                                          : "Pausar"}
                                      </Button>
                                    </Box>
                                  </Tooltip>
                                </Box>
                              </Grid>
                            </Grid>

                            {index <
                              complementos.complementoItens.length - 1 && (
                                <Divider />
                              )}
                          </React.Fragment>
                        )
                      )}
                    </Box>
                  </List>
                </AccordionDetails>
              </Accordion>
            </Box>
          ) : null
        )}
    </>
  );
};

export default ListComplements;
